import { GitError } from '../wasm-git-worker-errors.model';
import { GitErrorStatusCode } from './errors.enum';

export class InitGitError extends GitError {
  constructor(folderPath: string, append = true) {
    super(
      append
        ? `The repository at "${folderPath}" could not be initialized. This is most probably due to an outstanding browser update or missing disk space.`
        : folderPath,
    );
  }

  readonly gitErrorCode = GitErrorStatusCode.Init;
}
